import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Utils from '../utils';
import Form from './../../base/form.js';
import Spinner from './../../components/spinner.js';
import Analytics from '../../../base/wyn-analytics-module.js';
import {
  requestUrls,
  templateUrls
} from './../../../base/vars.js';
import UserHandler from './../../base/user.js';
import { EventHandler } from './../../../base/utils.js';

export default Backbone.View.extend({
  el: '.app-step-container',

  events: {
    'change select': 'updateAvailableOptions',
    'focusout input, select': 'handleValidation',
    'input input': 'handleValidation',
    'submit': 'onSubmit'
  },

  initialize() {
    this.model.unset('TwoFormActionCode');
    this.getTemplate();
  },

  getTemplate() {
    let preferences = Utils.getGdprAttributes('preferences');

    $.ajax({
      url: templateUrls.securityQuestionSetup,
      context: {
        onFail: {
          scrollToElement: $('body')
        }
      },
      success: (r) => {
        this.template = Handlebars.compile(r);
        this.render();
        window.App.Events.trigger('form:loaded');
        EventHandler.triggerEvent('security_questions', {
          pageName: 'security-questions',
          subscribeEstatements: Analytics.processSubscribeEStatements(preferences[0].PreferLevel),
          wyndhamRewardsPartnerOptIn: Analytics.processSubscribeEStatements(preferences[1].PreferLevel)
        });
        EventHandler.send(EventHandler.lazyLoad.rebind);
      }
    });
  },

  updateAvailableOptions(e) {
    let selects = $('.app-step-container').find('select'),
      selectedValues = [];

    selectedValues = selects.map((i, el) => {
      return el.value;
    }).get();

    $('.app-step-container').find('select option')
      .attr('disabled', false);

    this.handleValidation(e);

    $.each(selectedValues, (i, e) => {
      if (e.length > 0) {
        let selects = $('.app-step-container').find('select option:selected[value!=' + e + ']')
          .parent();
        $(selects).find('option[value="' + e + '"]')
          .attr('disabled', true);
      }
    });
  },

  handleValidation(e) {
    Utils.setBindingAttribute(this.model, e);
    Utils.validateBindingAttribute(this.model, e);
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
  },

  createSelectOptions() {
    let selects = $('.app-step-container select');

    $.each(selects, (i, e) => {
      let select = $(e);
      $.each(Utils.securityQuestions, (i, e) => {
        $(select).append('<option value="' + e.id + '">' + e.question + '</option>');
      });
    });
  },

  formatData() {
    let data = {
        data: []
      },
      questions = this.model.get('SecurityInfo.SecurityQuestions');

    $.each(questions, (i, e) => {
      data.data.push(e);
    });

    return data;
  },

  onSubmit(e) {
    let isValid = Utils.isValid(this.model);

    Form.disableFormField(this.$('.submit'));
    Spinner.appendTo(this.$('form'));

    if (requestUrls && requestUrls['postSecurityQuestions'] && isValid) {
      var data = JSON.stringify(this.formatData());
      $.ajax({
        url: requestUrls['postSecurityQuestions'],
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: data,
        context: {
          onFail: {
            scrollToElement: $('body'),
            formElement: this.$('form')
          }
        },
        success: (response, msg) => {
          UserHandler.getProfile((userProfile) => {
            EventHandler.triggerEvent('signin-complete', Analytics.getUserData(userProfile));
          });
          UserHandler.getSessionProfile()
            .then(() => {
              Utils.extendUserData(window.User);
              Backbone.history.loadUrl('book');
            });
        }
      });
    } else {
      Utils.scrollToTop();
      Form.enableFormField(this.$('.submit'));
      Spinner.remove(this.$('form'));
    }
  },

  render() {
    Utils.nextStep(1);
    this.$el.html(this.template(this.model.toJSON()));
    this.createSelectOptions();
    $('.submit').attr('disabled', true);
    Spinner.remove(this.$('form'));
    Utils.bindBackboneValidation(this);
    Utils.triggerFormChecks();
  }
});
